import React, { useEffect, useRef } from 'react';
import { Package } from 'lucide-react';
import { getIcon } from '../lib/icons';
import { serviceCards } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import HowItWorks from './HowItWorks';
import Tilt3D from './Tilt3D';

export default function Services() {
  const ref = useRef(null);
  const { t } = useLang();

  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && e.target.classList.add('in-view'));
    }, { threshold: 0.15 });
    ref.current?.querySelectorAll('.reveal').forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <>
    <section ref={ref} className="py-24 bg-[color:var(--brand-soft)]/40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="reveal text-[color:var(--brand)] uppercase tracking-[0.4em] text-xs mb-4">{t('services.eyebrow')}</p>
          <h2 className="reveal text-4xl md:text-5xl font-light text-[color:var(--ink)] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>{t('services.title')}</h2>
          <div className="reveal mx-auto w-16 h-[2px] bg-[color:var(--brand)]" />
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {serviceCards.map((sc, i) => {
            const Ico = getIcon(sc.icon, Package);
            return (
              <div key={i} className="reveal w-full md:w-[calc(50%-12px)] lg:w-[calc(25%-18px)]">
                <Tilt3D className="svc-card bg-white rounded-md overflow-hidden border border-[color:var(--line)] group">
                  <div className="aspect-[16/10] overflow-hidden bg-slate-200">
                    <img src={sc.image} alt={sc.title} className="svc-img w-full h-full object-cover" />
                  </div>
                  <div className="p-6">
                    <div className="icon-bubble inline-flex items-center justify-center w-12 h-12 rounded-full bg-[color:var(--brand-soft)] text-[color:var(--brand)] mb-4">
                      <Ico size={22} />
                    </div>
                    <h3 className="text-lg font-semibold text-[color:var(--ink)] mb-2">{sc.title}</h3>
                    <p className="text-[color:var(--muted)] text-sm leading-relaxed">{sc.desc}</p>
                  </div>
                </Tilt3D>
              </div>
            );
          })}
        </div>
      </div>
    </section>

    {/* Directly below Our Services */}
    <HowItWorks />
    </>
  );
}
